import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { fetchApiData } from "../../../redux/reducers/commonApiSlice";
import { initiatedCallDetails } from "../../../data/ApiEndpoints";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { formattedLongDate } from "../../common-data/Converts";
import InitiatedJobStats from "./InitiatedJobStats";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
// import ReInitiateJobForm from "./re-initiate-jobs/ReInitiateJobForm";
import AddButton from "../../payouts-wtf/common/AddButton";
import JobForm from "./JobForm";
import CampaignFilters from "../campaign-filters/CampaignFilters";

const InitiatedJobs = ({
  userInfoData,
  rowData,
  callFunction,
  closeInitiateModal,
}) => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.common);

  const [isPage, setIsPage] = useState(0);
  const iniTbData = {
    allData: [],
    pagination: [],
    allJonStats: {},
  };
  const [tbDatas, setTbDatas] = useState(iniTbData);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const iniModValues = {
    isModalOpen: false,
  };
  const [modValues, setModValues] = useState(iniModValues);
  const iniFilters = {
    selStatus: "",
  };
  const [allFilters, setAllFilters] = useState(iniFilters);

  const onClickReset = () => {
    setAllFilters(iniFilters);
  };

  const closeModal = () => {
    setModValues(iniModValues);
    setIsAllSelected(false);
    setSelectedRows([]);

    if (rowData.job_id) {
      const filters = {
        job_id: rowData.job_id,
        page: isPage + 1,
        limit: 10,
      };

      getInitiatedCallDetails(filters);
    }
  };

  const handleCheckboxChange = (event, row) => {
    const isChecked = event.target.checked;

    const updatedRows = tbDatas.allData.map((r) =>
      r.uid === row.uid ? { ...r, checked: isChecked } : r
    );

    setSelectedRows(
      isChecked
        ? [...selectedRows, { ...row, checked: isChecked }]
        : selectedRows.filter((selectedRow) => selectedRow.uid !== row.uid)
    );

    tbDatas.allData = updatedRows;
  };

  const handleToggleAllClick = (event) => {
    const isChecked = event.target.checked;

    const updatedRows = tbDatas.allData.map((row) => ({
      ...row,
      checked: isChecked,
    }));

    setSelectedRows(isChecked ? updatedRows : []);
    setIsAllSelected(isChecked);

    tbDatas.allData = updatedRows;
  };

  function getInitiatedCallDetails(filters) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: initiatedCallDetails,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (rowData?.job_id) {
      const filters = {
        job_id: rowData.job_id,
        status: allFilters.selStatus?.value ? allFilters.selStatus.value : "",
        page: isPage + 1,
        limit: 10,
      };

      getInitiatedCallDetails(filters);
    }
  }, [rowData?.job_id, isPage, allFilters.selStatus]);

  useEffect(() => {
    if (data?.status && !error) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: data?.data || [],
        pagination: data?.pagination || [],
        allJonStats: data?.call_stats || {},
      }));
    } else {
      setTbDatas(iniTbData);
    }
  }, [data, error]);

  const tbColumns = [
    {
      dataField: "select",
      text: (
        <div
          className="input-with-label"
          style={{ justifyContent: "flex-start" }}
        >
          <input
            type="checkbox"
            onChange={(event) => handleToggleAllClick(event)}
            checked={isAllSelected}
          />
          {/* <label htmlFor="select">
            {isAllSelected ? "Unselect All" : "Select All"}
          </label> */}
        </div>
      ),
      formatter: (_, row) => {
        const isDisbaled = false;

        return (
          <div className="tbDataFlexCenter checkbox-container">
            <input
              type="checkbox"
              onChange={(event) => handleCheckboxChange(event, row)}
              checked={row.checked}
              disabled={isDisbaled}
            />
          </div>
        );
      },
    },
    {
      dataField: "_cl",
      text: "Client Number",
      formatter: (_, row) => {
        return <span className="tb-data">{row?._cl || "NA"}</span>;
      },
    },
    {
      dataField: "status",
      text: "Call Status",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "_ts",
      text: "Call Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?._ts ? formattedLongDate(row._ts) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "_drm",
      text: "Call Duration (Minutes)",
      formatter: (_, row) => {
        return <span className="tb-data">{row?._drm || "-"}</span>;
      },
    },
    {
      dataField: "uid",
      text: "uid",
      formatter: (_, row) => {
        return (
          <span className="tb-data txt-small" style={{ textTransform: "none" }}>
            {row?.uid || "-"}
          </span>
        );
      },
    },
    {
      dataField: "_ivid",
      text: "Campaign ID",
      formatter: (_, row) => {
        return (
          <span className="tb-data txt-small" style={{ textTransform: "none" }}>
            {row?._ivid || "-"}
          </span>
        );
      },
    },
    {
      dataField: "job_id",
      text: "JOB ID",
      formatter: (_, row) => {
        return (
          <span className="tb-data txt-small" style={{ textTransform: "none" }}>
            {row?.job_id || "-"}
          </span>
        );
      },
    },
    {
      dataField: "_se",
      text: "Region",
      formatter: (_, row) => {
        return <span className="tb-data">{row?._se || "NA"}</span>;
      },
    },
    {
      dataField: "_fu",
      text: "Recording Link",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?._fu ? (
              <a href={row?._fu}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-box-arrow-up-right"
                  viewBox="0 0 16 16"
                  style={{
                    color: "#5356FF",
                    width: "35px",
                    height: "35px",
                  }}
                >
                  <path
                    fillRule="evenodd"
                    d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                  />
                  <path
                    fillRule="evenodd"
                    d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                  />
                </svg>
              </a>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-ban"
                viewBox="0 0 16 16"
                style={{
                  color: "gray",
                  width: "35px",
                  height: "35px",
                  cursor: "not-allowed",
                }}
              >
                <path d="M15 8a6.97 6.97 0 0 0-1.71-4.584l-9.874 9.875A7 7 0 0 0 15 8M2.71 12.584l9.874-9.875a7 7 0 0 0-9.874 9.874ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0" />
              </svg>
            )}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Re Initiate Job Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          <ModalHeadAndClose title={`Re Initiate Job`} onClose={closeModal} />

          <JobForm
            isReInitiate={true}
            selectedRows={selectedRows}
            userInfoData={userInfoData}
            closeModal={closeModal}
            callFunction={callFunction}
            closeInitiateModal={closeInitiateModal}
          />
        </div>
      </Modal>

      <CampaignFilters
        onClickReset={onClickReset}
        filters={allFilters}
        setFilters={setAllFilters}
      />

      <InitiatedJobStats allJobStats={tbDatas.allJonStats} />

      <div className="flexEnd">
        {/* <AddButton
          buttonText={isAllSelected ? "Unselect All" : "Select All"}
          onClickButton={handleToggleAllClick}
        /> */}
        <AddButton
          buttonText="Re Initiate Job"
          onClickButton={() => setModValues({ isModalOpen: true })}
          isDiabled={selectedRows?.length === 0}
        />
      </div>

      {loading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="overflowAuto separatedTable mt15">
          <PaymentLinkTable
            tableData={tbDatas.allData}
            tableColumns={tbColumns}
            tablePagination={tbDatas.pagination}
            isPage={isPage}
            setIsPage={setIsPage}
          />
        </div>
      )}
    </>
  );
};

export default InitiatedJobs;
